module.exports = __webpack_public_path__ + "static/media/hingeFrameAssembly.302b3348.png";